import { GetConferenceDataDashboard } from 'domain/usecases/dashboard/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetConferenceDataDashboard
  implements GetConferenceDataDashboard
{
  private readonly url: string;

  private readonly httpClient: HttpClient<GetConferenceDataDashboard.Model>;

  constructor(
    url: string,
    httClient: HttpClient<GetConferenceDataDashboard.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  getConferenceData = async (
    params: GetConferenceDataDashboard.Params,
  ): Promise<GetConferenceDataDashboard.Model> => {
    let query = '';
    if (params.query) {
      query = '?';
      Object.entries(params.query).forEach(([key, value]) => {
        query += `${key}=${value}&`;
      });
    }

    const httpResponse = await this.httpClient.request({
      url: `${this.url}${query}`,
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
